// const $ = require('jquery');
import WOW from "wow.js/dist/wow.js";
import "slick-carousel/slick/slick.js";
import objectFitImages from 'object-fit-images';

$(function(){

    // object-fit-imagesの利用
    objectFitImages('.img-ofi', {})

    // 固定ヘッダーの横スクロール対応
    const element = document.querySelector('.js-scroll-x')
    window.addEventListener('scroll', () => {
        element.style.left = -window.pageXOffset + 'px'
    })

    // SP版: ドロワーメニューの開閉
    $('.btn-burger').on('click',function() {
        if($(this).hasClass('active')){
            $(this).removeClass('active');
            $('.header-nav, .lp-nav').removeClass('opened');
        } else {
            $(this).addClass('active');
            $('.header-nav, .lp-nav').addClass('opened');
        }
    })

    // SP版: サブメニューのアコーディオン表示
    $('.menu-first.sub').on('click', '> .sub-menu > .check', function (e) {
        // preventDefault()
        let dropdown = $(this).parents('.sub')
        dropdown.toggleClass('opened')
        dropdown.find('.menu-second').slideToggle()
    })

    // 遷移先のページ内アンカーへ移動
    var headerHeight = $('.header').outerHeight();
    var urlHash = location.hash;
    var animeSpeed = 500;
    if(urlHash) {
        $('body,html').stop().scrollTop(0);
        setTimeout(function(){
            var target = $(urlHash);
            var position = target.offset().top - headerHeight;
            $('body,html').stop().animate({scrollTop:position}, animeSpeed);
        }, 100);
    }

    // 機能紹介: アンカースクロール
    $('a[href^="#feature-"]').on({
        'click': function(){
            var href= $(this).attr("href");
            var target = $(href);
            var position = target.offset().top - headerHeight;
            $('body,html').stop().animate({scrollTop:position}, animeSpeed);
            return false;
        }
    });

    // TOPページ: バナーのスライダー
    $('.slide-top-banner').slick({
        infinite: true,
        arrows: true,
        prevArrow: '<div class="prv"></div>',
        nextArrow: '<div class="nxt"></div>',
        slidesToShow: 4,
        autoplay: true,
        autoplaySpeed: 5000,
        responsive: [
            {
            breakpoint: 599,
            settings: {
                slidesToShow: 1,
                variableWidth: true,
                }
            }
        ]
    })

    // TOPページ: セミナーのスライダー
    $('.slide-top-seminar').slick({
        infinite: true,
        arrows: true,
        prevArrow: '<div class="prv"></div>',
        nextArrow: '<div class="nxt"></div>',
        slidesToShow: 3,
        autoplay: false,
        autoplaySpeed: 3000,
        responsive: [
            {
            breakpoint: 599,
            settings: {
                slidesToShow: 1,
                variableWidth: true,
                }
            }
        ]
    })

    // Worksアプリストアページで使用 [ /create/store.html ]
    $('.slider').slick({
        infinite: false,
        arrows: true,
        prevArrow: '<div class="prev"></div>',
        nextArrow: '<div class="next"></div>',
        slidesToShow: 3,
        autoplay: true,
        autoplaySpeed: 3000,

        responsive: [
            {
            breakpoint: 1024,
            settings: {
                slidesToShow: 3,
                infinite: true
            }
            },
            {
            breakpoint: 599,
            settings: {
                slidesToShow: 2,
                arrows: false,
            }
            },
            {
            breakpoint: 300,
            settings: "unslick"
            }
        ]
    });

    // ページの先頭に戻るボタン
    $('.footer-backtop__button').on('click',function () {
        $('body,html').animate({
            scrollTop: 0
        }, 500);
        return false;
    })

    // スクロール追従バナー
    var display = function () {
        if ($(this).scrollTop() > 150) {
            $(".follow-banner, .footer-backtop").fadeIn();
        } else {
            $(".follow-banner, .footer-backtop").fadeOut();
        }
    }
    $(window).on("scroll", display);
    $(".follow-banner .close-btn a").on("click", function () {
        $(".follow-banner").fadeOut();
        $(window).off("scroll", display);
    })

    // PCとSPで処理を分岐
    // SPの処理
    if (window.matchMedia('(max-width:599px)').matches) {
        // ログインメニューのスライド表示
        // $('.sub-nav__login').on('click',function() {
        //     if($(this).hasClass('active')){
        //         $(this).removeClass('active');
        //         $('.menu-slide').removeClass('opened');
        //     } else {
        //         $(this).addClass('active');
        //         $('.menu-slide').addClass('opened');
        //     }
        // });
    // PCの処理
    } else if (window.matchMedia('(min-width:600px)').matches) {
        // ログインメニューのスライド表示
        // $('.sub-nav__login').hover(function() {
        //     $(this).find('.menu-slide').stop().slideDown();
        // }, function() {
        //     $(this).find('.menu-slide').stop().slideUp();
        // })
    }

    // PCのブレイクポイントでリロード
    const breakPoint = 599;
    let resizeFlag;

    window.addEventListener('load',()=>{
        if ( breakPoint < window.innerWidth){
        resizeFlag = false;
        } else {
        resizeFlag = true;
        }
        resizeWindow();
    },false);

    const resizeWindow = () =>{
        window.addEventListener('resize',()=>{
        if( breakPoint < window.innerWidth && resizeFlag){
            window.location.reload();
            resizeFlag = false;
        } 
        else if ( breakPoint >= window.innerWidth && !(resizeFlag)) {
            resizeFlag = true;
        }
        },false);
    }

    // お知らせ: 記事アイテムの段階的表示
    $(function () {
        var show = 9;
        var num = 6;
        var contents = '#news .news-list li';

        // 最初に非表示にする要素
        $(contents + ':nth-child(n + ' + (show + 1) + ')').addClass('is-hidden');

        // 「もっと見る」ボタンクリックで追加表示
        $('.news-more button').on('click', function () {
            $(contents + '.is-hidden').slice(0, num).removeClass('is-hidden');
            if ($(contents + '.is-hidden').length === 0) {
            $('.news-more').fadeOut();
            }
        });

        // 初期件数が全体数以上なら「もっと見る」を表示しない
        var kosuu = $('#news .news-list li').length;
        if (show < kosuu) {
            $('.news-more').css('display', 'block');
        }
    });
    // var show = 9;
    // var num = 6;
    // var contents = '#news .news-list li';
    // $(contents + ':nth-child(n + ' + (show + 1) + ')').addClass('is-hidden');
    // $('.news-more button').on('click', function () {
    //     $(contents + '.is-hidden').slice(0, num).removeClass('is-hidden');
    //     if ($(contents + '.is-hidden').length == 0) {
    //     $('.news-more').fadeOut();
    //     }
    // });

    // var kosuu = $('#news .news-list li').length;
    // if (show >= kosuu){
    //     $('.news-more').css('display','none');
    // }

    // 下層ページ メインビジュアルのアニメーション
    if (
        $("#faq,#information,#contact,#plan,#free,#basic,#standard,#use,#create,#webinar,#webinar-detail,#download,#consulting,#about,#feature,#news,#plan-detail,#case,.blog")
        .length
    ) { new WOW().init(); }

    // よくある質問: アコーディオン表示
    $(".faq-item__question").on("click", function(e) {
        e.preventDefault();
        if ($(this).hasClass("faq-item__question--open")) {
            $(this).removeClass("faq-item__question--open");
            $(this)
            .closest(".faq-item")
            .find(".faq-item__answer")
            .removeClass("faq-item__answer--open");
            $(this)
            .closest(".faq-item")
            .find(".faq-item__answer")
            .css("max-height", "0");
        } else {
            var height = 85;
            $(this)
            .closest(".faq-item")
            .find(".faq-item__answer")
            .children()
            .each(function() {
                height = height + $(this).outerHeight(true);
            });
            $(this).addClass("faq-item__question--open");
            $(this)
            .closest(".faq-item")
            .find(".faq-item__answer")
            .addClass("faq-item__answer--open");
            $(this)
            .closest(".faq-item")
            .find(".faq-item__answer")
            .css("max-height", height);
        }
    });

    var headerHeight = $('.header').outerHeight(); // fixedのヘッダーの高さを取得
    var urlHash = location.hash; // URLハッシュを取得
    var animeSpeed = 500; // スクロールのアニメーションスピード
    if(urlHash) {
        $('body,html').stop().scrollTop(0);
        setTimeout(function(){
            var target = $(urlHash);
            var position = target.offset().top - headerHeight;
            $('body,html').stop().animate({scrollTop:position}, animeSpeed);
        }, 100);
    }
    $('a[href^="#sec-"]').on({
        'click': function(){
            var href= $(this).attr("href");
            var target = $(href);
            var position = target.offset().top - headerHeight;
            $('body,html').stop().animate({scrollTop:position}, animeSpeed);
            return false;
        }
    });

    // グローバルメニューのカレント表示
    $(function(){
        $('.menu-first a').each(function(){
            var $href = $(this).attr('href');
            if(location.href.match($href)) {
            $(this).addClass('active');
            } else {
            $(this).removeClass('active');
            }
        });
    });

});
